export type FeatureFlagValue = boolean | string | number | undefined;

export const TreatmentInfoV2FlagKey = 'treatment-info-v2-flag';
export const NeerCrystalFlagKey = 'neer-crystal-flag';

export function isFeatureFlagEnabled(value: FeatureFlagValue): boolean {
  return value === true || value === 'true';
}
